(function (window, $) {
  const namespace = "dropdown";

  /** 创建下拉选择器
   *
   * @class DropDown
   * @extends Emitter
   * @param {Object} data - 配置选项
   * @param {string} nameKey='name' - 选项显示字段的key
   * @param {Array<{name, onClick}>} data=[] - 下拉选项数组，每个选项必须包含nameKey指定的字段
   * @param {Function} slotItem - 自定义选项内容渲染函数，参数为选项数据
   * @param {JQuery} $input - 触发下拉的输入框元素
   * @param {string} minWidth='auto' - 下拉框最小宽度
   * @fires DropDown#toggleShow
   * @throws {Error} 当$input无效时抛出错误
   */
  class DropDown extends DropDownProxy {
    constructor({
      customClass = "", // 自定义类名
      trigger = "click", // hover
      data = [], // { name, value }[]
      slotItem,
      value,
      ...opt
      // $input,
      // $refrence,
      // minWidth = "auto",
      // maxWidth,
      // placement = "left",
    }) {
      super({
        // $input,
        // $refrence,
        trigger, // hover
        ...opt,
        // minWidth,
        // maxWidth,
        // placement,
      });

      // if ($input?.length === 0) {
      //   throw new Error("DropDown [Error] => $input");
      // }

      this.value = value || null;
      // this.nameKey = nameKey;
      this.data = data;
      this.slotItem = slotItem;

      this.$list = $(`<ul class="${namespace}_select_dropdown_ul ${customClass}"></ul>`);

      this.setup();
    }

    createItem(item) {
      const name = item.name;
      const value = item.value;
      const itemClass = `${namespace}_select_dropdown_item`;
      const $item = $(`<li class="${itemClass} ${value === this.value ? "active" : ""}"></li>`);
      $item.append(typeof this.slotItem === "function" ? this.slotItem(item) : name);

      $item.on("click", () => {
        if (value === this.value) return;
        this.setValue(value);
        this.emitter.emit("change", this.value);
        this.toggleShow();
      });
      return $item;
    }

    updateData(data) {
      this.data = data;
      this.isShow && this.renderItem();
    }

    setValue(_value) {
      this.value = _value;
      this.isShow && this.renderItem();
    }

    getValue() {
      return this.value;
    }

    renderItem() {
      this.$list.empty();
      this.data.forEach((item) => this.$list.append(this.createItem(item)));
    }

    setup() {
      this.$html.append(this.$list);
      this.emitter.on("toggleShow", (isShow) => isShow && this.renderItem());
    }
  }

  window.DropDown = DropDown;
})(window, jQuery);
